import { useState, useEffect } from "react";
import classes from "./StudioEquipment.module.css";
import EquipmentPopUp from "./EquipmentPopUp";
import { NotificationModal } from "./NotificationModal";
import { useStudioErstellen } from "../../../store/studioErstellenStore";

const EquipmentBoxPhone = ({ name, fromEditor }) => {
    const { studioData, updateStudioData } = useStudioErstellen();
    const [popUpActive, setPopUpActive] = useState(false);
    const [equipmentItems, setEquipmentItems] = useState([{ name: '', count: 1, id: Date.now() }]);
    const [isActive, setIsActive] = useState(() => {
        return !!(studioData.equipment && 
                 studioData.equipment[name] && 
                 studioData.equipment[name].length > 0);
    });
    const [editingItem, setEditingItem] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [pendingChecked, setPendingChecked] = useState(false);

    const handleToggleActive = (checked) => {
        if (!checked && studioData.equipment?.[name]?.length > 0) {            
            setShowModal(true);
            setPendingChecked(checked);
            return;
        }
        
        setIsActive(checked);
        if (checked) {
            openPopUp();
        }
    };

    const handleValidation = (items, currentId, newName) => {
        let isValid = true;
        const newErrors = {
            name: ""
        };

        const isDuplicate = studioData.equipment?.[name]?.some(item => 
            item.id !== currentId && 
            item.name.trim().toLowerCase() === newName.trim().toLowerCase()
        );

        if (isDuplicate) {
            newErrors.name = "Name schon vorhanden.";
            isValid = false;
        }

        return { isValid, errors: newErrors };
    };

    const editEquipment = (item) => {
        setEditingItem(item);
        setEquipmentItems([{ ...item }]);
        setPopUpActive(true);
    };

    const handleSave = (updatedEquipment) => {
        updateStudioData('equipment', updatedEquipment);
        setIsActive(true);
    };

    const deleteEquipment = (itemToDelete) => {
        if (itemToDelete) {
            const updatedEquipment = {
                ...studioData.equipment,
                [name]: studioData.equipment[name].filter(item => item.id !== itemToDelete.id)
            };
            updateStudioData('equipment', updatedEquipment);
        }
        setEquipmentItems([{ name: '', count: 1, id: "" }]);
        setEditingItem(null);
        setPopUpActive(false);
        if (studioData.equipment[name].length === 0) {
            setIsActive(false);
        }
    };

    const openPopUp = () => {
        setPopUpActive(true);
        setIsActive(true);
    };
    
    const closePopUp = () => {
        if (!studioData.equipment?.[name]?.length) {
            setIsActive(false);
        }
        setPopUpActive(false);
        setEditingItem(null);
        setEquipmentItems([{ 
            name: '', 
            count: 1, 
            id: `temp-${Date.now()}`
        }]);
    };
    
    const handleModalConfirm = () => {
        setShowModal(false);
        setIsActive(false);
        const updatedEquipment = { ...studioData.equipment };
        delete updatedEquipment[name];
        updateStudioData('equipment', updatedEquipment);
    };

    const handleModalCancel = () => {
        setShowModal(false);
        setIsActive(true);
    };

    const truncateText = (text, limit = 25) => {
        if (text.length > limit) {
            return text.substring(0, limit - 3) + '...';
        }
        return text;
    };

    useEffect(() => {
        setIsActive(!!(studioData.equipment?.[name]?.length > 0));
    }, [studioData.equipment, name]);

    return (
        <>
            <div 
                className={classes.equipmentBoxPhone}
                style={{
                    marginBottom: studioData.equipment?.[name]?.length > 0 ? 20 : 0,
                }}
            >
                <span className="semiboldMedium">{name}</span>
                <div className={classes.switchContainer}>
                    <label className={classes.switch}>
                        <input 
                            type="checkbox"
                            checked={isActive}
                            onChange={(e) => handleToggleActive(e.target.checked)}
                        />
                            <span className={classes.slider}></span>
                    </label>
                </div>
            </div>
            {studioData.equipment?.[name]?.map((item, index) => (
                <div key={item.id || index} className={classes.equipmentItem}>
                    <div className={classes.equipmentItemContainer}>
                        <span className="semiboldXs">{truncateText(item.name)}</span>
                        <span className={`${classes.equipmentItemCount} semiboldXs`}>
                            {item.count}
                        </span>
                    </div>
                    <button 
                        className={`${classes.equipmentEditButton} semiboldXs`}
                        onClick={() => editEquipment(item)}
                    >
                        Bearbeiten
                    </button>
                </div>
            ))}
            {studioData.equipment?.[name]?.length > 0 && 
                <div className={classes.equipmentAddButtonContainer}>
                    <button onClick={openPopUp} className={`${classes.equipmentAddButton} semiboldXs`}>
                        Weiteres Licht hinzufügen
                    </button>
                </div>
            }
            <div className={classes.heavyLine}></div>
            {popUpActive && 
                <>
                    <EquipmentPopUp 
                        fromEditor={fromEditor}
                        closePopUp={closePopUp} 
                        name={name} 
                        equipmentItems={equipmentItems} 
                        setEquipmentItems={setEquipmentItems}
                        editingItem={editingItem}
                        deleteEquipment={deleteEquipment}
                        onSave={handleSave}
                        handleValidation={handleValidation}
                    />
                </>
            }
            <NotificationModal 
                open={showModal}
                onBackdropClick={() => handleModalCancel()}
                onConfirm={handleModalConfirm}
                onCancel={handleModalCancel}
                onDelete={handleModalConfirm}
            >
                {name}
            </NotificationModal>
        </>
    );
};

export default EquipmentBoxPhone;